import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { useAuth } from "@clerk/clerk-react";
import { Loader2 } from "lucide-react";

import { AppShell } from "@/components/app-shell";

export const Route = createFileRoute("/_authed")({
  component: AuthedLayout,
});

/**
 * AuthedLayout is the single boundary for every authenticated page. It owns the
 * auth gate (loading → spinner, signed-out → redirect to the public landing)
 * and renders the shared chrome (AppShell) around the page outlet. Pages
 * mounted under this layout are guaranteed a session and inherit the header +
 * tab navigation with no per-page nav code.
 */
function AuthedLayout() {
  const { isLoaded, isSignedIn } = useAuth();

  // Auth state still resolving — show a spinner rather than authed chrome or a
  // premature redirect (avoids a flash of authenticated UI / broken API calls).
  if (!isLoaded) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="size-6 animate-spin text-[var(--muted-foreground)]" />
      </div>
    );
  }

  // No session — send anonymous visitors to the public landing (which hosts
  // sign-in). No authenticated chrome or API call is issued.
  if (!isSignedIn) {
    return <Navigate to="/" />;
  }

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
